import moment from "moment";
import "moment-timezone";

export function formatNotificationDateTime(timezone, created_at) {
  const zonedMoment = timezone?.value && created_at ? moment.utc(created_at).tz(timezone.value) : null;
  return {
    date: zonedMoment ? zonedMoment.format("MM/DD/YYYY") : "",
    day: zonedMoment ? zonedMoment.format("ddd") : "",
    time: zonedMoment ? zonedMoment.format("HH:mm:ss") : "",
  };
}
